import { createActions, createReducer } from 'reduxsauce'

import ArquivosContratoService from '../../servicos/ArquivosContratoService'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaArquivosContratoInicio: [],
    buscaArquivosContratoSucesso: ['arquivosContrato'],
    buscaArquivosContratoErro: ['erro'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    lista: [],
}

// Ação para busca completa
Creators.buscaArquivosContrato = filtro => {
    return dispatch => {
        dispatch(Creators.buscaArquivosContratoInicio())
        let serv = new ArquivosContratoService()
        return serv
            .consultar(filtro)
            .then(response => dispatch(Creators.buscaArquivosContratoSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaArquivosContratoErro(error)))
    }
}

const buscaArquivosContratoInicio = (state = INITIAL_STATE, action) => ({ ...state, carregando: true, erro: null })

const buscaArquivosContratoErro = (state = INITIAL_STATE, action) => {
    return { ...state, erro: action.erro, carregando: false }
}

const buscaArquivosContratoSucesso = (state = INITIAL_STATE, action) => {
    return { ...state, lista: action.arquivosContrato, carregando: false }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_ARQUIVOS_CONTRATO_INICIO]: buscaArquivosContratoInicio,
    [Types.BUSCA_ARQUIVOS_CONTRATO_ERRO]: buscaArquivosContratoErro,
    [Types.BUSCA_ARQUIVOS_CONTRATO_SUCESSO]: buscaArquivosContratoSucesso,
})
